<template>
    <div class="card-slider">
        <DefSliderWrapper>
            <swiper
                :modules="modules"
                :slides-per-view="1"
                :pagination="{ clickable: true }"
                navigation
            >
                <swiper-slide
                    v-for="(item, i) in result"
                    :key="i"
                >
                    <DefImg :result="item"/>
                </swiper-slide>
            </swiper>
        </DefSliderWrapper>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination } from 'swiper';
const pictures = require('../../MOCKED_DATA/catalog-page').catalogData.catalogSectionList.items[0].pictures;

import DefImg from "../def/DefImg/DefImg";

export default {
    name: 'CardSlider',
    components: {
        Swiper,
        SwiperSlide,
        DefImg,
    },
    props: {
        result: {
            type: Array,
            default: () => pictures
        }
    },
    data() {
        return {
            modules: [Navigation, Pagination],
        }
    },
}
</script>

<style lang="scss" scoped>
.card-slider {
    position: relative;
    img{
        display: block;
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
    }
    :deep(.swiper-pagination-bullet){
        width: 6px;
        height: 6px;
        &:not(:last-child){
            margin-right: 6px;
        }
    }
    :deep(.def-slider-wrapper){
        margin-bottom: 8px;
    }
}
</style>